import * as actionType from 'constants/action-constants';

const initialState = {
  filterhotels: [],
  totalHotels: null,
  hasMoreScrollHotels: true,
  filters: [],
  error: '',
  errorCode: null,
  status: null,
  overallScore: null,
  highestScore: null,
  lowestScore: null,
  isLoading: false,
  newBrand: null,
  newPid: null,
  isHotelsLoading: false,
};
/**
 *
 * @param {*} state - The Intial state
 * @param {*} action - The action object containing action type and payload
 * @returns - Updated state object
 */
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // Reset error case.
    case actionType.RESET_ERROR:
      return {
        ...state,
        error: '',
        errorCode: null,
      };

    // Get hotels list cases.
    case actionType.GET_HOTELS_REQUEST:
      return {
        ...state,
        isHotelsLoading: true,
        status: '',
        error: '',
      };
    case actionType.GET_HOTELS_SUCCESS: {
      let filterhotels = [],
        hasMoreScrollHotels = true;

      if (action.payload.isScroll) {
        filterhotels = [
          ...state.filterhotels,
          ...(action.payload.res.hotels || []),
        ];
      } else {
        filterhotels = action.payload.res.hotels || [];
      }

      if (action.payload.res.hotels) {
        if (action.payload.res?.hotels?.length < 10) {
          hasMoreScrollHotels = false;
        } else {
          hasMoreScrollHotels = true;
        }
      } else {
        hasMoreScrollHotels = false;
      }

      return {
        ...state,
        isHotelsLoading: false,
        status: action.payload.res.status,
        filterhotels,
        filters: action.payload.res.filters,
        hasMoreScrollHotels,
        overallScore: action.payload.res.overallScore,
        highestScore: action.payload.res.highestScore,
        lowestScore: action.payload.res.lowestScore,
        totalHotels: action.payload.res.totalCount,
      };
    }
    case actionType.GET_HOTELS_FAILURE:
      return {
        ...state,
        isHotelsLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
      };

    // Delete hotels cases.
    case actionType.DELETE_HOTEL_REQUEST:
      return {
        ...state,
        error: '',
        status: '',
        isLoading: true,
      };
    case actionType.DELETE_HOTEL_SUCCESS: {
      const filterhotels = state.filterhotels.filter(
        hotel => action.payload !== hotel.id
      );

      return {
        ...state,
        status: 'success',
        isLoading: false,
        filterhotels,
        totalHotels: state.totalHotels - 1,
      };
    }
    case actionType.DELETE_HOTEL_FAILURE:
      return {
        ...state,
        status: 'failure',
        isLoading: false,
        error: `${action.payload.code} - ${action.payload.message}`,
      };

    // Create duplicate hotel cases.
    case actionType.CREATE_DUPLICATE_HOTEL_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        status: '',
      };
    case actionType.CREATE_DUPLICATE_HOTEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: 'success',
        newBrand: action.payload.newBrand,
        newPid: action.payload.newPid,
      };
    case actionType.CREATE_DUPLICATE_HOTEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
      };

    // Create duplicate dashbord hotel.
    case actionType.CREATE_DUPLICATE_DASHBOARD_HOTEL_REQUEST:
      return {
        ...state,
        isLoading: true,
        status: '',
        error: '',
      };
    case actionType.CREATE_DUPLICATE_DASHBOARD_HOTEL_SUCCESS: {
      const { sortBy, sortOrder } = action.payload.params;
      const filterhotels = [...state.filterhotels];

      const {
        contactInformation: { address1: address },
        contactInformation: { phone: phoneNumber },
        contactInformation: {
          country: { country_code: country },
        },
        rating,
        brand,
        name: hotelName,
        pid,
        score,
        status,
        updatedAt,
      } = action.payload.information;

      const duplicateHotel = {
        address,
        brand,
        hotelName,
        pid,
        score,
        status,
        phoneNumber,
        rating,
        country,
        updatedAt,
        newBrand: action.payload.newBrand,
        newPid: action.payload.newPid,
      };

      filterhotels.push(duplicateHotel);

      // Position of the hotel after adding according to the sort option.
      if (sortBy === 'score') {
        if (sortOrder === 'ASCENDING') {
          filterhotels.sort(
            (a, b) => parseFloat(a.score) - parseFloat(b.score)
          );
        } else if (sortOrder === 'DESCENDING') {
          filterhotels.sort(
            (a, b) => parseFloat(b.score) - parseFloat(a.score)
          );
        }
      } else if (sortBy === 'lastModified') {
        if (sortOrder === 'ASCENDING') {
          filterhotels.sort((a, b) => a.updatedAt - b.updatedAt);
        } else if (sortOrder === 'DESCENDING') {
          filterhotels.sort((a, b) => b.updatedAt - a.updatedAt);
        }
      }

      return {
        ...state,
        filterhotels,
        isLoading: false,
        status: 'success',
      };
    }
    case actionType.CREATE_DUPLICATE_DASHBOARD_HOTEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
